import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Home from '../pages/Home';
import LoadingSpinner from '../components/shared/LoadingSpinner';

// Lazy-loaded page components
const About = React.lazy(() => import('../pages/About'));
const Services = React.lazy(() => import('../pages/Services'));
const WebDevelopmentPage = React.lazy(() => import('../pages/WebDevelopmentPage'));
const MobileDevelopmentPage = React.lazy(() => import('../pages/MobileDevelopmentPage'));
const UIUXDesignPage = React.lazy(() => import('../pages/UIUXDesignPage'));
const ManagedITPage = React.lazy(() => import('../pages/ManagedITPage'));
const CloudInfrastructurePage = React.lazy(() => import('../pages/CloudInfrastructurePage'));
const CybersecurityPage = React.lazy(() => import('../pages/CybersecurityPage'));
const AutomationPage = React.lazy(() => import('../pages/AutomationPage'));
const MedicalProcessOutsourcingPage = React.lazy(() => import('../pages/MedicalProcessOutsourcingPage'));
const LegalProcessOutsourcingPage = React.lazy(() => import('../pages/LegalProcessOutsourcingPage'));
const RemoteStaffingPage = React.lazy(() => import('../pages/RemoteStaffingPage'));
const DigitalMarketingPage = React.lazy(() => import('../pages/DigitalMarketingPage'));
const Testimonials = React.lazy(() => import('../pages/Testimonials'));
const Portfolio = React.lazy(() => import('../pages/Portfolio'));
const Contact = React.lazy(() => import('../pages/Contact'));
const GetStarted = React.lazy(() => import('../pages/GetStarted'));
const PrivacyPolicy = React.lazy(() => import('../pages/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('../pages/TermsOfService'));
const CookiePolicy = React.lazy(() => import('../pages/CookiePolicy'));
const NotFound = React.lazy(() => import('../pages/NotFound'));

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route
          path="about"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <About />
            </Suspense>
          }
        />
        <Route
          path="services"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Services />
            </Suspense>
          }
        />
        <Route
          path="services/managed-it"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <ManagedITPage />
            </Suspense>
          }
        />
        <Route
          path="services/cloud-infrastructure"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CloudInfrastructurePage />
            </Suspense>
          }
        />
        <Route
          path="services/automation"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AutomationPage />
            </Suspense>
          }
        />
        <Route
          path="services/web-development"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <WebDevelopmentPage />
            </Suspense>
          }
        />
        <Route
          path="services/mobile-development"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <MobileDevelopmentPage />
            </Suspense>
          }
        />
        <Route
          path="services/ui-ux-design"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <UIUXDesignPage />
            </Suspense>
          }
        />
        <Route
          path="services/cybersecurity"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CybersecurityPage />
            </Suspense>
          }
        />
        <Route
          path="services/medical-process-outsourcing"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <MedicalProcessOutsourcingPage />
            </Suspense>
          }
        />
        <Route
          path="services/legal-process-outsourcing"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <LegalProcessOutsourcingPage />
            </Suspense>
          }
        />
        <Route
          path="services/remote-staffing"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <RemoteStaffingPage />
            </Suspense>
          }
        />
        <Route
          path="services/digital-marketing"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <DigitalMarketingPage />
            </Suspense>
          }
        />
        <Route
          path="testimonials"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Testimonials />
            </Suspense>
          }
        />

        <Route
          path="portfolio"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Portfolio />
            </Suspense>
          }
        />
        <Route
          path="contact"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path="get-started"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <GetStarted />
            </Suspense>
          }
        />
        <Route
          path="privacy-policy"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <PrivacyPolicy />
            </Suspense>
          }
        />
        <Route
          path="terms-of-service"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <TermsOfService />
            </Suspense>
          }
        />
        <Route
          path="cookie-policy"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CookiePolicy />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <NotFound />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
